export default "__VITE_ASSET__BrdhfFcE__"